__turbopack_context__.v({
  "hero": "ShareModal-module-scss-module__CpNpZG__hero",
  "heroAvatar": "ShareModal-module-scss-module__CpNpZG__heroAvatar",
  "heroBanner": "ShareModal-module-scss-module__CpNpZG__heroBanner",
  "nameRow": "ShareModal-module-scss-module__CpNpZG__nameRow",
  "profileBlock": "ShareModal-module-scss-module__CpNpZG__profileBlock",
});
